<div>
  <div class="margin-content">
    <my-horizontal-menu [menuEntries]="menuEntries"></my-horizontal-menu>
  </div>

  <router-outlet></router-outlet>
</div>
